module.exports = __webpack_public_path__ + "static/img/tourimg-4.0851da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/tourimg-4.png
// module id = tEPa
// module chunks = 1